import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { AircraftTypeDetailsWrapper } from "@/components/ui/Screens/Aircraft";
import { getAircraftTypeDetails } from "@/stores/apis/apiAircraft";
import Script from "next/script";

export async function getServerSideProps({ query }) {
	const { uid, preview = false } = query;
	let aircraftType = null;
	let data = await getAircraftTypeDetails(uid, preview);
	if (data.success) aircraftType = data.data;
	return {
		props: {
			uid: uid,
			aircraftType: aircraftType,
		},
	};
}

export default function AircraftTypes({ uid, aircraftType, ...props }) {
	return (
		<div className={styles.container}>
			<Head>
				<title>{aircraftType?.seo?.seo_title || "Aircraft Type Details"}</title>
				<link rel="icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="manifest" href="/site.webmanifest" />
				<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffb11a" />
				<meta name="msapplication-TileColor" content="#da532c" />
				<meta name="theme-color" content="#ffffff" />
				<meta
					name="description"
					content={
						aircraftType?.seo?.seo_description ||
						"Michigan's top rated private jet charter services, arrive on time and in style, service to the continental United States, call us for private or business travel services."
					}
				></meta>
				<meta
					property="og:image"
					content={
						aircraftType?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				></meta>
				<meta
					itemProp="thumbnailUrl"
					content={
						aircraftType?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				/>
				<meta
					name="twitter:image"
					content={
						aircraftType?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				></meta>
			</Head>
			<Script src="https://www.googletagmanager.com/gtag/js?id=G-VCNS22HF5D" />
			<Script id="google-analytics">
				{`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'G-VCNS22HF5D');
                `}
			</Script>

			<main style={{ padding: 0, width: "100%" }}>
				{aircraftType && <AircraftTypeDetailsWrapper aircraftType={aircraftType} {...props} />}
			</main>
		</div>
	);
}
